import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withDirectives as _withDirectives, vModelSelect as _vModelSelect, renderList as _renderList, normalizeClass as _normalizeClass, vShow as _vShow } from "vue"

const _hoisted_1 = { class: "space-y-6" }
const _hoisted_2 = { class: "bg-white shadow rounded-lg p-5" }
const _hoisted_3 = { class: "flex items-center justify-between" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-xl font-medium text-gray-800" }
const _hoisted_6 = { class: "mt-4 grid grid-cols-1 sm:grid-cols-3 gap-4" }
const _hoisted_7 = { class: "p-3 bg-gray-50 rounded" }
const _hoisted_8 = { class: "font-medium text-gray-800" }
const _hoisted_9 = { class: "text-sm text-gray-600" }
const _hoisted_10 = { class: "p-3 bg-gray-50 rounded" }
const _hoisted_11 = { class: "font-medium text-gray-800" }
const _hoisted_12 = { class: "text-sm text-gray-600" }
const _hoisted_13 = { class: "p-3 bg-gray-50 rounded" }
const _hoisted_14 = { class: "font-medium text-gray-800" }
const _hoisted_15 = { class: "text-sm text-gray-600" }
const _hoisted_16 = { class: "bg-white shadow rounded-lg p-5" }
const _hoisted_17 = { class: "flex items-center justify-between" }
const _hoisted_18 = { class: "text-right" }
const _hoisted_19 = { class: "font-medium text-gray-800" }
const _hoisted_20 = { class: "mt-4 grid grid-cols-1 sm:grid-cols-4 gap-4" }
const _hoisted_21 = { class: "p-3 border rounded" }
const _hoisted_22 = { class: "font-medium text-gray-800" }
const _hoisted_23 = { class: "p-3 border rounded" }
const _hoisted_24 = { class: "font-medium text-gray-800" }
const _hoisted_25 = { class: "p-3 border rounded" }
const _hoisted_26 = { class: "font-medium text-gray-800" }
const _hoisted_27 = { class: "p-3 border rounded" }
const _hoisted_28 = { class: "font-medium text-gray-800" }
const _hoisted_29 = { class: "flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3" }
const _hoisted_30 = { class: "flex items-center gap-2 w-full sm:w-1/2" }
const _hoisted_31 = { class: "flex items-center gap-3" }
const _hoisted_32 = { class: "text-sm text-gray-600" }
const _hoisted_33 = { class: "font-medium text-gray-800" }
const _hoisted_34 = { class: "bg-white shadow rounded-lg overflow-hidden" }
const _hoisted_35 = { class: "min-w-full divide-y divide-gray-200" }
const _hoisted_36 = { class: "bg-white divide-y divide-gray-100" }
const _hoisted_37 = { class: "px-4 py-3 align-top" }
const _hoisted_38 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_39 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_40 = { class: "text-xs text-gray-400 mt-1" }
const _hoisted_41 = { key: 0 }
const _hoisted_42 = {
  key: 1,
  class: "text-gray-400"
}
const _hoisted_43 = { class: "px-4 py-3 align-top text-right" }
const _hoisted_44 = { class: "text-sm text-gray-800" }
const _hoisted_45 = { class: "px-4 py-3 align-top text-right" }
const _hoisted_46 = { class: "text-sm text-gray-800" }
const _hoisted_47 = { class: "px-4 py-3 align-top text-right" }
const _hoisted_48 = { class: "px-4 py-3 align-top text-center" }
const _hoisted_49 = { class: "px-4 py-3 align-top" }
const _hoisted_50 = { class: "text-sm text-gray-800" }
const _hoisted_51 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_52 = { class: "px-4 py-3 align-top" }
const _hoisted_53 = { class: "text-sm text-gray-700" }
const _hoisted_54 = { class: "font-medium" }
const _hoisted_55 = { class: "text-xs text-gray-500 mt-1" }
const _hoisted_56 = { class: "font-medium" }
const _hoisted_57 = { class: "px-4 py-3 align-top text-center" }
const _hoisted_58 = ["onClick"]
const _hoisted_59 = {
  key: 0,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 mr-2",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_60 = {
  key: 1,
  xmlns: "http://www.w3.org/2000/svg",
  class: "h-4 w-4 mr-2 transform rotate-90",
  viewBox: "0 0 20 20",
  fill: "currentColor"
}
const _hoisted_61 = {
  colspan: 8,
  class: "px-6 py-4 bg-gray-50"
}
const _hoisted_62 = { class: "grid grid-cols-1 lg:grid-cols-2 gap-6" }
const _hoisted_63 = { class: "text-sm font-semibold text-gray-700 mb-2" }
const _hoisted_64 = { class: "flex flex-wrap gap-2" }
const _hoisted_65 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_66 = { class: "text-sm font-semibold text-gray-700 mb-2" }
const _hoisted_67 = { class: "space-y-2" }
const _hoisted_68 = { class: "flex items-center justify-between" }
const _hoisted_69 = { class: "text-sm font-medium text-gray-800" }
const _hoisted_70 = { class: "text-xs text-gray-500" }
const _hoisted_71 = { class: "text-sm text-gray-600 mt-1" }
const _hoisted_72 = {
  key: 1,
  class: "text-sm text-gray-500"
}
const _hoisted_73 = { class: "mt-4" }
const _hoisted_74 = { class: "text-sm text-gray-600" }
const _hoisted_75 = { class: "mt-2 p-3 bg-gray-800 text-gray-100 rounded text-xs overflow-auto" }
const _hoisted_76 = {
  key: 0,
  class: "p-6 text-center text-sm text-gray-500"
}

import { ref, computed } from 'vue'
import { toRaw } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'TreatmentPlanDetail',
  props: {
  data: {
    type: Object,
    required: true
  }
},
  setup(__props) {

const props = __props

const transaction = props.data?.Transaction ?? null
const auth = transaction?.Authorisation ?? transaction?.TransactionHeader ? props.data.Transaction.Authorisation : props.data.Transaction?.Authorisation ?? transaction?.Authorisation ?? props.data?.Transaction?.Authorisation ?? props.data?.Authorisation

// Use sensible fallbacks
const groups = computed(() => (auth?.GroupDetails ?? []).map(g => ({
  ...g,
  AllowedQuantity: Number(g.AllowedQuantity ?? 0),
  UsedQuantity: Number(g.UsedQuantity ?? 0)
})))

const search = ref('')
const statusFilter = ref('')
const expanded = ref(new Set())

function remaining(group) {
  const a = Number(group.AllowedQuantity ?? 0)
  const u = Number(group.UsedQuantity ?? 0)
  const rem = a - u
  return isNaN(rem) ? '–' : rem
}

function remainingClass(group) {
  const rem = Number(group.AllowedQuantity ?? 0) - Number(group.UsedQuantity ?? 0)
  if (rem <= 0) return 'text-red-600'
  if (rem <= Math.max(1, Math.floor((group.AllowedQuantity ?? 0) * 0.15))) return 'text-yellow-600'
  return 'text-green-600'
}

function statusBadgeClass(status) {
  if (!status) return 'bg-gray-100 text-gray-700'
  if (status.toUpperCase() === 'ACTIVE') return 'bg-green-100 text-green-800'
  if (status.toUpperCase() === 'INACTIVE') return 'bg-red-100 text-red-800'
  return 'bg-gray-100 text-gray-700'
}

function toggleExpand(i) {
  if (expanded.value.has(i)) expanded.value.delete(i)
  else expanded.value.add(i)
  // Vue won't track Set mutations for template reactivity, recreate it
  expanded.value = new Set([...expanded.value])
}

function isExpanded(i) {
  return expanded.value.has(i)
}

const filteredGroups = computed(() => {
  const q = search.value.trim().toLowerCase()
  return groups.value.filter(g => {
    if (statusFilter.value) {
      if ((g.LineStatus || '').toUpperCase() !== statusFilter.value.toUpperCase()) return false
    }
    if (!q) return true

    // fields to search: description, charge codes, charge descriptions, specialities
    const desc = (g.GroupTypeDescription || '').toLowerCase()
    if (desc.includes(q)) return true

    const charges = (g.ChargeDetails ?? []).some(c => {
      return (c.ChargeableCode || '').toLowerCase().includes(q) ||
        (c.Description || '').toLowerCase().includes(q) ||
        (c.Publication || '').toLowerCase().includes(q)
    })
    if (charges) return true

    const specs = (g.SpecialityDetails ?? []).some(s => (s.Speciality || '').toLowerCase().includes(q))
    if (specs) return true

    const nums = `${g.AllowedQuantity ?? ''} ${g.UsedQuantity ?? ''}`.toLowerCase()
    if (nums.includes(q)) return true

    return false
  })
})

function prettyPrint(obj) {
  try {
    return JSON.stringify(toRaw(obj), null, 2)
  } catch (e) {
    return String(obj)
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[3] || (_cache[3] = _createElementVNode("div", null, [
          _createElementVNode("h2", { class: "text-lg font-semibold text-gray-700" }, "Transaction"),
          _createElementVNode("p", { class: "text-sm text-gray-500" }, "Header details for this API response")
        ], -1)),
        _createElementVNode("div", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("div", { class: "text-sm text-gray-500" }, "Destination", -1)),
          _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(transaction)?.TransactionHeader?.DestinationIdentifier || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _cache[4] || (_cache[4] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Tran #", -1)),
          _createElementVNode("div", _hoisted_8, _toDisplayString(_unref(transaction)?.TransactionHeader?.TranNum), 1),
          _cache[5] || (_cache[5] = _createElementVNode("div", { class: "text-xs text-gray-500 mt-1" }, "Date", -1)),
          _createElementVNode("div", _hoisted_9, _toDisplayString(_unref(transaction)?.TransactionHeader?.TranDate), 1)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _cache[6] || (_cache[6] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Scheme / Option", -1)),
          _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(auth)?.Scheme) + " · " + _toDisplayString(_unref(auth)?.OptionCode), 1),
          _cache[7] || (_cache[7] = _createElementVNode("div", { class: "text-xs text-gray-500 mt-1" }, "Auth Seq", -1)),
          _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(auth)?.AuthSeq), 1)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _cache[8] || (_cache[8] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Member", -1)),
          _createElementVNode("div", _hoisted_14, _toDisplayString(_unref(auth)?.Firstnames) + " " + _toDisplayString(_unref(auth)?.Surname), 1),
          _cache[9] || (_cache[9] = _createElementVNode("div", { class: "text-xs text-gray-500 mt-1" }, "Member No / Dependant", -1)),
          _createElementVNode("div", _hoisted_15, _toDisplayString(_unref(auth)?.MembershipNumber) + " · " + _toDisplayString(_unref(auth)?.DependantCode), 1)
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_16, [
      _createElementVNode("div", _hoisted_17, [
        _cache[11] || (_cache[11] = _createElementVNode("div", null, [
          _createElementVNode("h3", { class: "text-md font-semibold text-gray-700" }, "Authorisation"),
          _createElementVNode("p", { class: "text-sm text-gray-500" }, "Program, dates and high-level details")
        ], -1)),
        _createElementVNode("div", _hoisted_18, [
          _cache[10] || (_cache[10] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Program", -1)),
          _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(auth)?.Program || '-'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_20, [
        _createElementVNode("div", _hoisted_21, [
          _cache[12] || (_cache[12] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Birthdate", -1)),
          _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(auth)?.BirthDate), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _cache[13] || (_cache[13] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Authorisation Start", -1)),
          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(auth)?.AuthorisationStartDate || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_25, [
          _cache[14] || (_cache[14] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Tranche", -1)),
          _createElementVNode("div", _hoisted_26, _toDisplayString(_unref(auth)?.Tranche || '-'), 1)
        ]),
        _createElementVNode("div", _hoisted_27, [
          _cache[15] || (_cache[15] = _createElementVNode("div", { class: "text-xs text-gray-500" }, "Authorisation Disease", -1)),
          _createElementVNode("div", _hoisted_28, [
            (_unref(auth)?.AuthorisationDisease?.length)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_unref(auth).AuthorisationDisease[0].ChronicDisease), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode("-")
                ], 64))
          ])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_29, [
      _createElementVNode("div", _hoisted_30, [
        _withDirectives(_createElementVNode("input", {
          type: "text",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((search).value = $event)),
          placeholder: "Search groups, charges, specialities...",
          class: "w-full px-3 py-2 border rounded-md focus:outline-none focus:ring-2 focus:ring-indigo-300"
        }, null, 512), [
          [_vModelText, search.value]
        ])
      ]),
      _createElementVNode("div", _hoisted_31, [
        _withDirectives(_createElementVNode("select", {
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((statusFilter).value = $event)),
          class: "px-10 py-2 border rounded-md"
        }, [...(_cache[16] || (_cache[16] = [
          _createElementVNode("option", { value: "" }, "All statuses", -1),
          _createElementVNode("option", { value: "ACTIVE" }, "ACTIVE", -1),
          _createElementVNode("option", { value: "INACTIVE" }, "INACTIVE", -1)
        ]))], 512), [
          [_vModelSelect, statusFilter.value]
        ]),
        _createElementVNode("div", _hoisted_32, [
          _cache[17] || (_cache[17] = _createTextVNode(" Showing ", -1)),
          _createElementVNode("span", _hoisted_33, _toDisplayString(filteredGroups.value.length), 1),
          _cache[18] || (_cache[18] = _createTextVNode(" groups ", -1))
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_34, [
      _createElementVNode("table", _hoisted_35, [
        _cache[25] || (_cache[25] = _createElementVNode("thead", { class: "bg-gray-50" }, [
          _createElementVNode("tr", null, [
            _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Group"),
            _createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Allowed"),
            _createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Used"),
            _createElementVNode("th", { class: "px-4 py-3 text-right text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Remaining"),
            _createElementVNode("th", { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Status"),
            _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Dates"),
            _createElementVNode("th", { class: "px-4 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Extras"),
            _createElementVNode("th", { class: "px-4 py-3 text-center text-xs font-medium text-gray-500 uppercase tracking-wider" }, "Actions")
          ])
        ], -1)),
        _createElementVNode("tbody", _hoisted_36, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (group, idx) => {
            return (_openBlock(), _createElementBlock("tr", {
              key: group.GroupTypeSeq,
              class: "hover:bg-gray-50"
            }, [
              _createElementVNode("td", _hoisted_37, [
                _createElementVNode("div", _hoisted_38, _toDisplayString(group.GroupTypeDescription), 1),
                _createElementVNode("div", _hoisted_39, "ChronicSeq: " + _toDisplayString(group.ChronicDiseaseSeq), 1),
                _createElementVNode("div", _hoisted_40, [
                  _cache[19] || (_cache[19] = _createTextVNode("Charge codes: ", -1)),
                  (group.ChargeDetails?.length)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_41, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.ChargeDetails, (c, i) => {
                          return (_openBlock(), _createElementBlock("span", {
                            key: i,
                            class: "inline-flex items-center px-2 py-0.5 mr-1 rounded text-xs bg-indigo-50 text-indigo-700"
                          }, _toDisplayString(c.ChargeableCode), 1))
                        }), 128))
                      ]))
                    : (_openBlock(), _createElementBlock("span", _hoisted_42, "–"))
                ])
              ]),
              _createElementVNode("td", _hoisted_43, [
                _createElementVNode("div", _hoisted_44, _toDisplayString(group.AllowedQuantity ?? '-'), 1)
              ]),
              _createElementVNode("td", _hoisted_45, [
                _createElementVNode("div", _hoisted_46, _toDisplayString(group.UsedQuantity ?? 0), 1)
              ]),
              _createElementVNode("td", _hoisted_47, [
                _createElementVNode("div", {
                  class: _normalizeClass(["text-sm font-medium", remainingClass(group)])
                }, _toDisplayString(remaining(group)), 3)
              ]),
              _createElementVNode("td", _hoisted_48, [
                _createElementVNode("span", {
                  class: _normalizeClass(['inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium', statusBadgeClass(group.LineStatus)])
                }, _toDisplayString(group.LineStatus), 3)
              ]),
              _createElementVNode("td", _hoisted_49, [
                _createElementVNode("div", _hoisted_50, _toDisplayString(group.GroupStartDate || '-'), 1),
                _createElementVNode("div", _hoisted_51, _toDisplayString(group.GroupEndDate || '—'), 1)
              ]),
              _createElementVNode("td", _hoisted_52, [
                _createElementVNode("div", _hoisted_53, [
                  _cache[20] || (_cache[20] = _createTextVNode("PMB: ", -1)),
                  _createElementVNode("span", _hoisted_54, _toDisplayString(group.PMBIndicator || '-'), 1)
                ]),
                _createElementVNode("div", _hoisted_55, [
                  _cache[21] || (_cache[21] = _createTextVNode("Specialities: ", -1)),
                  _createElementVNode("span", _hoisted_56, _toDisplayString((group.SpecialityDetails?.length ?? 0)), 1)
                ])
              ]),
              _createElementVNode("td", _hoisted_57, [
                _createElementVNode("button", {
                  onClick: ($event: any) => (toggleExpand(idx)),
                  class: "inline-flex text-sky-700 border border-sky-700 items-center px-3 py-1 bg-transparent hover:text-white rounded hover:bg-sky-700 text-sm"
                }, [
                  (!isExpanded(idx))
                    ? (_openBlock(), _createElementBlock("svg", _hoisted_59, [...(_cache[22] || (_cache[22] = [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ]))]))
                    : (_openBlock(), _createElementBlock("svg", _hoisted_60, [...(_cache[23] || (_cache[23] = [
                        _createElementVNode("path", {
                          "fill-rule": "evenodd",
                          d: "M5 10a1 1 0 011-1h8a1 1 0 110 2H6a1 1 0 01-1-1z",
                          "clip-rule": "evenodd"
                        }, null, -1)
                      ]))])),
                  _createTextVNode(" " + _toDisplayString(isExpanded(idx) ? 'Collapse' : 'Details'), 1)
                ], 8, _hoisted_58)
              ])
            ]))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredGroups.value, (group, idx) => {
            return _withDirectives((_openBlock(), _createElementBlock("tr", {
              key: group.GroupTypeSeq + '-details'
            }, [
              _createElementVNode("td", _hoisted_61, [
                _createElementVNode("div", _hoisted_62, [
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_63, "Specialities (" + _toDisplayString(group.SpecialityDetails?.length ?? 0) + ")", 1),
                    _createElementVNode("div", _hoisted_64, [
                      (group.SpecialityDetails?.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.SpecialityDetails, (s, i) => {
                            return (_openBlock(), _createElementBlock("span", {
                              key: i,
                              class: "inline-flex items-center px-2 py-1 bg-white border rounded text-xs text-gray-700"
                            }, _toDisplayString(s.Speciality), 1))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_65, "No specialities"))
                    ])
                  ]),
                  _createElementVNode("div", null, [
                    _createElementVNode("h4", _hoisted_66, "Charge Details (" + _toDisplayString(group.ChargeDetails?.length ?? 0) + ")", 1),
                    _createElementVNode("div", _hoisted_67, [
                      (group.ChargeDetails?.length)
                        ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(group.ChargeDetails, (c, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: i,
                              class: "p-3 bg-white border rounded"
                            }, [
                              _createElementVNode("div", _hoisted_68, [
                                _createElementVNode("div", _hoisted_69, _toDisplayString(c.ChargeableCode || '—'), 1),
                                _createElementVNode("div", _hoisted_70, _toDisplayString(c.Publication || '—'), 1)
                              ]),
                              _createElementVNode("div", _hoisted_71, _toDisplayString(c.Description || '—'), 1)
                            ]))
                          }), 128))
                        : (_openBlock(), _createElementBlock("div", _hoisted_72, "No charges listed"))
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_73, [
                  _createElementVNode("details", _hoisted_74, [
                    _cache[24] || (_cache[24] = _createElementVNode("summary", { class: "cursor-pointer text-indigo-600" }, "Show raw group JSON", -1)),
                    _createElementVNode("pre", _hoisted_75, _toDisplayString(prettyPrint(group)), 1)
                  ])
                ])
              ])
            ])), [
              [_vShow, isExpanded(idx)]
            ])
          }), 128))
        ])
      ]),
      (filteredGroups.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_76, " No groups match your filters. "))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})